import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Wheat, Handshake, Warehouse, ShieldCheck, TrendingUp, Lightbulb, ArrowRight, Banknote, Truck, Snowflake } from 'lucide-react';
import { services } from '../data/mock';

const ServicesPage = () => {
  const iconMap = {
    Wheat: Wheat,
    Handshake: Handshake,
    Warehouse: Warehouse,
    ShieldCheck: ShieldCheck,
    TrendingUp: TrendingUp,
    Lightbulb: Lightbulb,
    Banknote: Banknote,
    Truck: Truck,
    Snowflake: Snowflake,
  };

  return (
    <div className="pt-24">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-[#FAFFEE] to-[#EDEDFE] relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute -top-40 -right-40 w-96 h-96 bg-[#D3FF62]/20 rounded-full blur-3xl" />
          <div className="absolute bottom-0 -left-40 w-96 h-96 bg-[#CACAFC]/30 rounded-full blur-3xl" />
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-2 text-[#0C6951] font-semibold uppercase tracking-wider">
              <Link to="/" className="hover:text-[#004534]">Home</Link>
              <ChevronRight className="w-4 h-4" />
              Services
            </span>
            <h1 className="text-4xl md:text-5xl font-bold text-[#004534] mt-4 mb-6 leading-tight">
              Our Services
            </h1>
            <p className="text-xl text-[#0C6951] leading-relaxed">
              Comprehensive agricultural solutions from farm to business, empowering farmers and serving industries across India.
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service) => {
              const IconComponent = iconMap[service.icon];
              return (
                <div
                  key={service.id}
                  className="bg-[#FAFAFF] rounded-3xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group"
                >
                  <div className="w-16 h-16 bg-[#D3FF62] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                    {IconComponent && <IconComponent className="w-8 h-8 text-[#004534]" />}
                  </div>
                  <h3 className="text-xl font-semibold text-[#004534] mb-4">{service.title}</h3>
                  <p className="text-[#807979] leading-relaxed mb-6">{service.description}</p>
                  <Link
                    to="/contact"
                    className="inline-flex items-center gap-2 text-[#004534] font-medium hover:gap-3 transition-all duration-200"
                  >
                    Learn More <ArrowRight className="w-4 h-4" />
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-[#FAFFEE]">
        <div className="container mx-auto px-4">
          <div className="bg-[#004534] rounded-3xl p-12 md:p-16 text-center relative overflow-hidden">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-0 right-0 w-64 h-64 bg-[#D3FF62] rounded-full blur-3xl" />
              <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#D3FF62] rounded-full blur-3xl" />
            </div>
            
            <div className="relative z-10 max-w-2xl mx-auto">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                Need a Custom Solution?
              </h2>
              <p className="text-white/80 mb-8">
                We understand that every business has unique requirements. Contact us to discuss your specific agricultural needs.
              </p>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 bg-[#D3FF62] text-[#004534] px-8 py-4 rounded-full font-semibold hover:bg-[#c4f050] transition-all duration-200 hover:-translate-y-0.5"
              >
                Get In Touch
                <ArrowRight className="w-5 h-5" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
